import { SidebarNavItem } from "@/types/sidebar";

interface SidebarConfig {
  adminSidebar: SidebarNavItem[];
  employeeSidebar: SidebarNavItem[];
  superAdminSidebar: SidebarNavItem[];
}

export const sidebarConfig: SidebarConfig = {
  superAdminSidebar: [
    {
      title: "Dashboard",
      items: [
        {
          title: "Home",
          href: "/superadmin",
          items: [],
        },
        {
          title: "Admins",
          items: [
            {
              title: "Admins",
              href: "/superadmin/admins",
              items: [],
            },
            {
              title: "Admins Activity",
              href: "/superadmin/admin-activity",
              items: [],
            },
          ],
        },
        {
          title: "Employees",
          items: [
            {
              title: "Employees",
              href: "/superadmin/employees",
              items: [],
            },
            {
              title: "Employees Activity",
              href: "/superadmin/employee-activity",
              items: [],
            },
            {
              title: "Leads Activity",
              href: "/superadmin/employees/lead-activity",
              items: [],
            },
            {
              title: "Attendance Reports",
              href: "/superadmin/employees/attendance-reports",
              items: [],
            },
            {
              title: "Leaves",
              href: "/superadmin/employees/leaves",
              items: [],
            },
            {
              title: "Check-in Management",
              href: "/superadmin/checkin-management",
              items: [],
            },
          ],
        },
      ],
    },
  ],
  adminSidebar: [
    {
      title: "Admin Dashboard",
      items: [
        {
          title: "Dashboard",
          href: "/admin",
          items: [],
        },
        // {
        //   title: "All Employees",
        //   href: "/admin/all-employees",
        //   items: [],
        // },
        {
          title: "Employees",
          items: [
            {
              title: "All Employees",
              href: "/admin/employees",
              items: [],
            },
            {
              title: "Checkins",
              href: "/admin/checkins",
              items: [],
            },
            {
              title: "Monthly Report",
              href: "/admin/employees/monthly-report",
              items: [],
            },
            {
              title: "Permissions",
              href: "/admin/employee-permissions",
              items: [],
            },
            {
              title: "Leave Applications",
              href: "/admin/leave-applications",
              items: [],
            },

            // {
            //   title: "Leads",
            //   href: "/admin/leads",
            //   items: [],
            // },

            {
              title: "Allowance",
              href: "/admin/allowance",
              items: [],
            },
            {
              title: "Salary Timesheets",
              href: "/admin/salary-timesheets",
              items: [],
            },
            {
              title: "Salaries",
              href: "/admin/salaries",
              items: [],
            },
            // {
            //   title: "Loan",
            //   href: "/admin/loan",
            //   items: [],
            // },
          ],
        },
        {
          title: "Company",
          items: [
            {
              title: "Holiday Settings",
              href: "/admin/holidays",
              items: [],
            },
            {
              title: "Company Holidays",
              href: "/admin/company-holidays",
              items: [],
            },
            {
              title: "Announcements",
              href: "/admin/announcements",
              items: [],
            },
          ],
        },

        // {
        //   title: "Loans",
        //   items: [
        //     {
        //       title: "Requested Loans",
        //       href: "/admin/loan",
        //       items: [],
        //     },
        //     {
        //       title: "Other Loans",
        //       href: "/admin/other-loans",
        //       items: [],
        //     },
        //   ],
        // },
        {
          title: "Loans",
          href: "/admin/other-loans",
          items: [],
        },

        {
          title: "Leads",
          items: [
            {
              title: "Leads",
              href: "/admin/leads",
              items: [],
            },
            {
              title: "Upload Leads",
              href: "/admin/leads/upload",
              items: [],
            },
            {
              title: "Lead Reports",
              href: "/admin/leads/reports",
              items: [],
            },
          ],
        },

        {
          title: "Attendance",
          items: [
            // {
            //   title: "Employee Attendances",
            //   href: "/admin/employee-attendances",
            //   items: [],
            // },
            {
              title: "Attendance Requests",
              href: "/admin/employee-attendance-requests",
              items: [],
            },
            {
              title: "Attendance Change Logs",
              href: "/admin/attendance-change-logs",
              items: [],
            },
          ],
        },

        {
          title: "Todos",
          // href: "/admin/todos",
          items: [
            {
              title: "All Todos",
              href: "/admin/todos",
              items: [],
            },
            {
              title: "Todos Kanban Board",
              href: "/admin/todos/employee-progress",
              items: [],
            },
          ],
        },

        // {
        //   title: "Performance",
        //   items: [
        //     {
        //       title: "Performance Logs",
        //       href: "/admin/performance/logs",
        //       items: [],
        //     },
        //     {
        //       title: "Performance Reports",
        //       href: "/admin/performance/reports",
        //       items: [],
        //     },
        //   ],
        // },
      ],
    },
  ],

  employeeSidebar: [
    {
      title: "Employee Dashboard",
      items: [
        {
          title: "Dashboard",
          href: "/employee",
          items: [],
        },
        {
          title: "Requests",
          items: [
            {
              title: "Leave Applications",
              href: "/employee/leave-applications",
              items: [],
            },
            {
              title: "Allowance",
              href: "/employee/allowance",
              items: [],
            },
            {
              title: "Loan",
              href: "/employee/loan",
              items: [],
            },
          ],
        },
        {
          title: "Leads",
          items: [
            {
              title: "Upload Leads",
              href: "/employee/leads/upload",
              items: [],
            },
            {
              title: "Leads",
              href: "/employee/leads",
              items: [],
            },
            {
              title: "All Leads",
              href: "/employee/leads/all-leads",
              items: [],
            },
            {
              title: "Lead Reminders",
              href: "/employee/leads/reminders",
              items: [],
            },
            {
              title: "Lead Reports",
              href: "/employee/leads/reports",
              items: [],
            },
          ],
        },

        {
          title: "Todos",
          href: "/employee/todos",
          items: [],
        },
        {
          title: "My Salary Slips",
          href: "/employee/profile/my-salary",
          items: [],
        },
        {
          title: "My Attendance",
          href: "/employee/profile/attendance",
          items: [],
        },
        {
          title: "Company Holidays",
          href: "/employee/company-holidays",
          items: [],
        },
        {
          title: "Announcements",
          href: "/employee/announcements",
          items: [],
        },
        // {
        //   title: "Employees",
        //   items: [
        //     {
        //       title: "Employees",
        //       href: "/admin/employees",
        //       items: [],
        //     },
        //     {
        //       title: "Holidays",
        //       href: "/admin/holidays",
        //       items: [],
        //     },
        //   ],
        // },
      ],
    },
  ],
};
